import { useFlags } from '@atlaskit/flag';
import { Unsubscribe } from 'firebase/auth';
import { DocumentSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { showErrorFlag } from 'core/utilities/flags-helper';
import { useNavigate } from 'react-router-dom';

interface IUseDocumentProps {
  apiService: any; // TODO: Add type
  uid?: string;
  navigateTo?: string;
}

export const useDocument = <T>({ apiService, uid, navigateTo }: IUseDocumentProps) => {
  const flags = useFlags();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    if (uid) {
      const handleSnapshot = (snap: DocumentSnapshot<T>) => {
        setData(snap.data() as T);
        setLoading(false);
      };
      const handleSubscriptionError = (error: any) => {
        showErrorFlag('An error occurred', 'This document could not be loaded, it may have been removed.', flags);
        setLoading(false);
      };

      let unsubscribe: Unsubscribe;
      unsubscribe = apiService.onDocSnapshot(uid, handleSnapshot, handleSubscriptionError);

      return () => {
        unsubscribe();
      };
    }
  }, [apiService, flags, uid, navigateTo, navigate]);

  useEffect(() => {
    if (!data && navigateTo && !loading) {
      navigate(navigateTo);
    }
  }, [navigateTo, navigate, data, loading]);

  return { data, loading };
};
